<template>
    <div>
         <Breadcrumb :headers="headers"></Breadcrumb>
        <List
            url="getFileProducts" :tanle="tanle" :update="updateList" 
            :operat="operat"  :isAdd="false" 
            :data="searchData" @download="download" @download2="download2">

           <div slot="Filter">
                <label style="margin-left:10px;">Product Category：</label>
                <el-select v-model="searchData.ProductCategory"  @change="searchData.ProductModel ='all'" placeholder="">
                    <el-option 
                        v-for="item in productCategoryList"
                        :key="item.ID"
                        :label="item.ProductCategory"
                        :value="item.ID">
                    </el-option>
                </el-select>

                <label style="margin-left:10px;">Product Model：</label>
                <template>
                    <el-select style="width:200px;" v-model="searchData.ProductModel" placeholder="">
                        <el-option
                            v-for="item in productModelList"
                            :key="item.ID"
                            :label="item.ProductModel"
                            :value="item.ID">
                        </el-option>
                    </el-select>
               
                </template>

                <label style="margin-left:10px;">Document Type：</label>
                <el-select style="width:200px;" v-model="searchData.DocumentType" placeholder="">
                    <el-option
                        v-for="item in documentTypeList"
                        :key="item.ID"
                        :label="item.DocumentType"
                        :value="item.ID">
                    </el-option>
                </el-select>

                <el-button @click="updateList++" type="primary" style="margin-left:10px;">Search</el-button>
            </div>
            <div slot="Tail" style="margin-top:40px; margin-bottom:10px;">
                <label >Note: For more information, please contact our marketing team.</label>
            </div>
        </List>
    <iframe id="ifile" name="ifile" :src="iframeUrl" style="display:none"></iframe>
    </div>
</template>

<script>
import List from "../components/common/List.vue";
import Breadcrumb from "../components/common/Breadcrumb.vue";
// import { productCategoryList,productModel7List,documentTypeList,DocumentType } from "@/components/Products/data.js";

// import { unshiftAll } from "@/methods/selection.js";
export default {
    components:{
        List,
        Breadcrumb
    },
    data () {
        return {
            tanle:[{name:"Name",label:"File Name",type:"file",width:'500px'},{name:"DocumentTypeName",label:"Document Type",width:'200px'},{name:"PublishTime",label:"Last Updated"},{name:"Size",label:"Size"}],
            updateList:0,
            updateBlock:false,
            updateForm:{},
            headers:[{label:"Home",path:"/dashboard"},{label:"Products",path:"/products"}],
            iframeUrl:"",
            searchData:{
                Key:"",
                ProductCategory:"all",
                ProductModel:"all",
                DocumentType:"all"
            },
            productCategoryList:"",
            productModelList:"",
            documentTypeList:"",
            operat: [{
                text: "Download",
                eventName: "download2",
                type: "primary"
            }]
        };
    },
    created () {},
    mounted () {
        this.$http.get("getAllProductCategory",{},(data)=>{
            this.productCategoryList = data.data;
            this.productCategoryList.unshift({ProductCategory:"all"});
        });
        this.$http.get("getProductModel",{},(data)=>{
            this.productModelList = data.data;
            this.productModelList.unshift({ProductModel:"all"});
        });
        this.$http.get("getAllDocumentType",{},(data)=>{
            this.documentTypeList = data.data;
            this.documentTypeList.unshift({DocumentType:"all"});
        });
    },
    methods:{
        // dealListData (data) {
        //     for(let i in data) {
        //         data[i].DocumentTypeName = DocumentType[data[i].DocumentType];
        //     }
        //     return data;
        // },
        download2 (data) {
            this.download(data.Name);
        },
        download (data) {
            this.iframeUrl = `${this.$http.host}akuvoxwiki/download/partnerManage/marketingMaterials/${data}`;
        }
    },
    computed: {},
    watch:{
        'searchData.ProductCategory'() {
            this.$http.get("getAllProductModel",{CategoryID:this.searchData.ProductCategory},(data)=>{
                this.productModelList = data.data;
                 this.productModelList.unshift({ProductModel:"all"});
            });
        }
    }      
};
</script>
